import React from 'react'
import { Field } from '@ztechapps/webui.form'
import { TextInput } from '@ztechapps/webui.input'
import { useRegisterContext } from './Context'
import { ShowIf } from '@ztechapps/webui.util'

export const RegisterForm = ({ children }) => {
  const { includePassword } = useRegisterContext()

  return (
    <React.Fragment>
      <Field
        name="username"
        label="Email"
        type="email"
        component={TextInput}
        help="We need your email address so we can easily contact you. Do not worry we hate also spam!"
      />

      <Field
        name="phone"
        label="Mobile Phone"
        type="tel"
        component={TextInput}
        help="If we cannot contact you via email, we can use this mobile phone number else.  Do not worry we hate also spam!"
      />

      <Field name="fullName" label="Full name" component={TextInput} help="A way for us to address you." />

      <ShowIf condition={includePassword}>
        <Field
          name="password"
          type="password"
          label="Password"
          required
          minLength={6}
          component={TextInput}
          help="We suggest to use the password generator of the browser."
        />
      </ShowIf>

      {children}
    </React.Fragment>
  )
}
